import { useState, useEffect } from 'react';
import { API_BASE_URL } from '../../config';
import { fixUrlProtocol } from '../../utils/misc';

const useVehicleWorkshopAlerts = (token) => {
    const [vehicleWorkshopAlerts, setVehicleWorkshopAlerts] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [lastPage, setLastPage] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const fetchVehicleWorkshopAlerts = async (page) => {
        if (loading) return;

        setLoading(true);

        const url = fixUrlProtocol(`${API_BASE_URL}/garages/workshop-alerts?page=${page}`);

        try {
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const result = await response.json();
            setVehicleWorkshopAlerts((prev) => [...prev, ...result.data]);
            setCurrentPage(result.meta.current_page);
            setLastPage(result.meta.last_page);
        } catch (err) {
            setError(err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (vehicleWorkshopAlerts.length === 0 && token) {
            fetchVehicleWorkshopAlerts(1);
        }
    }, [token]);

    const hasMore = lastPage !== null && currentPage < lastPage;

    /**
     * Load more alerts when the user scrolls to the bottom of the list
     */
    const loadMore = () => {
        if (hasMore) {
            fetchVehicleWorkshopAlerts(currentPage + 1);
        }
    };

    /**
     * Force refresh the list of alerts
     */
    const forceRefresh = () => {
        setVehicleWorkshopAlerts([]);
        setCurrentPage(1);
        setLastPage(null);
        return fetchVehicleWorkshopAlerts(1);
    };

    return { vehicleWorkshopAlerts, loading, error, loadMore, hasMore, forceRefresh };
};

export default useVehicleWorkshopAlerts;